import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Level} from '../../classes/level/level';
import {AuthenticationService} from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LevelService {

  constructor(private http: HttpClient,
              private authenticationService: AuthenticationService) {
  }

  public getLevels(active: boolean, level: number = null) {
    let activeNumber: number = active === true ? 1 : 0;
    let levelQuery = level === null ? this.authenticationService.getUserLevelId() : level;
    return this.http.get(`levels?active=` + activeNumber + `&level=` + levelQuery);
  }

  public getLevel(id: number) {
    return this.http.get(`levels/` + id);
  }

  public postLevel(level: Level) {

    return this.http.post(`levels`, level);
  }

  public patchLevel(id, level: Level) {
    return this.http.patch(`levels/` + id, level);
  }

}
